import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  PDP_ADD_TO_CART,
  PDP_CLICK_ON_VARIANT,
  PDP_CSW_NEW_ALGO,
  TrackingEvent
} from 'shared/experiments/consts'
import { INIT_XSELL_TOP_SLIDER } from 'shared/store/ducks/events'

import {
  bindTrackingEvents,
  isExperimentEnabled,
  trackEvent
} from 'shared/experiments/utils'
import { subscribe } from 'shared/store'

const bindPdpTracking = () => {
  // Button stays between prescription updates
  const addToCartTracking: TrackingEvent = {
    selector: '[data-clientside-hook~="add2CartForm"] [type=submit]',
    event: 'click',
    trackingEvent: PDP_ADD_TO_CART
  }
  bindTrackingEvents([addToCartTracking])

  // Variants are dynamic
  const variantsContainer = document.getElementById('h_ProductVariants')
  if (variantsContainer) {
    variantsContainer.addEventListener('click', (event: MouseEvent) => {
      if (
        (<HTMLElement>event.target).closest(
          '[data-clientside-hook~="productVariant__link"]'
        )
      ) {
        trackEvent(PDP_CLICK_ON_VARIANT)
      }
    })
  }
}

const bindSliderTracking = () => {
  const sliderTrackingDefs: TrackingEvent[] = [
    {
      selector: '.o-ProductSliderItem',
      event: 'click',
      trackingEvent: CSW_PRODUCT_CLICK
    },
    {
      selector: '.o-SliderHorizontal .o-SliderHorizontal__nav',
      event: 'click',
      trackingEvent: CSW_ARROW_CLICK
    }
  ]

  // Bind events after the slider pops in layout
  subscribe.after(INIT_XSELL_TOP_SLIDER, () =>
    requestAnimationFrame(() => bindTrackingEvents(sliderTrackingDefs))
  )
}

export default () => {
  if (!isExperimentEnabled(PDP_CSW_NEW_ALGO)) {
    return
  }

  bindPdpTracking()
  bindSliderTracking()
}
